import { FC } from "react";
import styled from "styled-components";

import { DATA_E2E_KEY, IPassengerInfo, IStyledAttributes } from "@ryde/shared";

import { RidePassengersCsvList } from "../../common";

const RidePassengerCsvListCellStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ride-passenger-csv-list-wrapper",
})`
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const RidePassengerCsvListCell: FC<{
  passengersInfo: IPassengerInfo[];
}> = ({ passengersInfo }) => {
  return (
    <RidePassengerCsvListCellStyled>
      <RidePassengersCsvList passengersInfo={passengersInfo} />
    </RidePassengerCsvListCellStyled>
  );
};
